import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SLEntity } from './entity';
import { SLEntityService } from './entity.service';
import { lookupParam } from '../../nav/utils';
import { NotifierService } from '../../ui';

@Injectable()
export class SLEntityResolver implements Resolve<SLEntity> {

  constructor(
    private router: Router,
    private entityService: SLEntityService,
    private notifier: NotifierService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): SLEntity | Observable<SLEntity> | Promise<SLEntity> {
    return new Promise<SLEntity>(async (resolve, reject) => {

      let entity_id = lookupParam(route, 'entity_id');

      this.notifier.startProgress();

      this.entityService
        .entity(entity_id)
        .subscribe((entity) => {
          
          if(entity) {
            return resolve(entity);
          }
          else {
            this.router.navigate(['shares-ledger', 'entities']);
            return resolve(null);
          }
        });
    });
  }
}